import MatchGame from './components/MatchGame'

import './App.css'

// These are the lists used in the application. You can move them to any component needed.

// Replace your code here
const App = () => <MatchGame />

export default App
